import React, { Fragment, useContext } from 'react';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
import { HIPAY_PSP_ID } from 'Components/widgets/payment-info/PaymentInfo.const';
import { formatApiDate } from 'Utils/date/apiDate';
import { t } from 'Src/i18n';
import { PaymentInfoContext } from 'Components/widgets/payment-info/PaymentInfoContext';
import { PaymentFormikInput } from 'Components/widgets/payment-info/paymentFormik';
type CreditCardContentProps = {
  hasFullAmount: boolean;
  paymentSchedule: PaymentSchedule;
  rePaymentSchedule?: RepaymentSchedule;
  totalAmount: string;
};
type Props = {
  hasFullAmount: boolean;
  isDisabled: boolean;
  paymentSchedule: PaymentSchedule;
  rePaymentSchedule?: RepaymentSchedule;
  totalAmount: string;
  hasNoPaymentMethods: boolean;
};

const CreditCardContent = ({
  hasFullAmount,
  rePaymentSchedule,
  paymentSchedule,
  totalAmount,
}: CreditCardContentProps) => {
  const { isFreeDeposit } = useContext(PaymentInfoContext);
  return (
    <TemplateString
      template={
        isFreeDeposit || hasFullAmount || !rePaymentSchedule
          ? t('booking.banking.paymentProvider.creditCard.totalAmount')
          : t('booking.banking.paymentProvider.creditCard.deposit')
      }
      values={
        !isFreeDeposit && !hasFullAmount && rePaymentSchedule
          ? {
              depositAmount: paymentSchedule.depositAmount.formattedValue,
              balanceAmount: rePaymentSchedule.amount.formattedValue,
              balanceDate: formatApiDate(rePaymentSchedule.deadline, t('booking.form.dateFormat')),
            }
          : {
              totalAmount,
            }
      }
      valuesClassName={{
        depositAmount: 'font-bold text-sienna',
        balanceAmount: 'font-bold text-sienna',
        totalAmount: 'font-bold text-sienna',
        balanceDate: 'font-bold',
      }}
    />
  );
};

const FormatedCardsAccepted = () => {
  const cardsAccepted = t('booking.banking.paymentProvider.creditCard.cardsAccepted');
  const cardsAcceptedParts = cardsAccepted?.split(':');

  if (cardsAcceptedParts.length === 2) {
    return (
      <Fragment>
        <span className="font-bold">{cardsAcceptedParts[0]}</span>: {cardsAcceptedParts[1]}
      </Fragment>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <Fragment>{cardsAccepted}</Fragment>;
};

export const CreditCardPaymentBlock = ({
  hasFullAmount,
  isDisabled,
  paymentSchedule,
  rePaymentSchedule,
  totalAmount,
  hasNoPaymentMethods,
}: Props) => {
  return hasNoPaymentMethods ? (
    <div className="my-25 max-w-full text-14 sm:max-w-4/5">
      <input type="hidden" name="paymentProviderId" value={HIPAY_PSP_ID} />
      <PaymentFormikInput
        type="radio"
        name="selectorPaymentProviderId"
        isDisabled={isDisabled}
        value={HIPAY_PSP_ID}
        label={
          <div className="max-w-full">
            <CreditCardContent
              hasFullAmount={hasFullAmount}
              rePaymentSchedule={rePaymentSchedule}
              paymentSchedule={paymentSchedule}
              totalAmount={totalAmount}
            />
            <span className="block">
              <FormatedCardsAccepted />
            </span>
          </div>
        }
      />
    </div>
  ) : (
    <div className="ml-20 mt-5 text-14">
      <CreditCardContent
        hasFullAmount={hasFullAmount}
        rePaymentSchedule={rePaymentSchedule}
        paymentSchedule={paymentSchedule}
        totalAmount={totalAmount}
      />
    </div>
  );
};
